import React, { useContext } from 'react';
import { GestureResponderEvent, StyleSheet, View, ViewStyle } from 'react-native';
import { ThemeContext, Touchable } from '..';

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (theme: Theme): Record<string, Record<string, string | number>> =>
  StyleSheet.create({
    frame: {
      backgroundColor: theme.colors.frame.backgroundColor,
      borderRadius: 3,
    },
  });

interface BaseFrameProps {
  onFrameTouched?: (event: GestureResponderEvent) => void;
  children?: React.ReactNode;
  style?: ViewStyle;
}

export const BaseFrame = ({ onFrameTouched, children = null, style }: BaseFrameProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  return (
    <View style={[styles.frame, style]}>
      {onFrameTouched ? (
        <Touchable onPress={onFrameTouched} underlayColor="white">
          <View>{children}</View>
        </Touchable>
      ) : (
        children
      )}
    </View>
  );
};
